import { app } from '../../../../../../app';
import { Controller } from './saaspass-cloud-directory.controller';

app.component('companyUserDirectoriesDirectoryGroupsSaaspassCloudDirectory', {
    bindings: {
        companyId: '<',
        directories: '<',
        groups: '<',
    },
    controller: Controller,
    templateUrl: require('./saaspass-cloud-directory.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/directory-groups/directory/saaspass-cloud-directory/saaspass-cloud-directory.component.js